import React, { useState, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import { useSnackbar } from 'notistack';
import { ACTIONS, MESSAGES } from '../../shared/constants';
import DataTable from '../../shared/data-table';
import {
  getAllProfile,
  deleteSelectedProfile,
  getPositionHomologationEngrana,
  getZones, 
  getRequired,
  getAllAirports,
  getProfilesByEmployee,
  updateDataRequired,
  SaveAllRequiredExcel
} from './logic';
//import ProfileTypeDetails from '../../Profile-type/Profile-type-detail';
import RequiredDetail from '../compensation/compensation-required';
import DeleteIcon from '@mui/icons-material/Delete';
import Edit from '@mui/icons-material/Edit';
import AddCircle from '@mui/icons-material/AddCircle';
import ErrorSnackbar from '../error-snackbar';
import BackDrop from '../../shared/backdropDE';
import { getAllPermissionsByProfile } from '../../shared/data-services/management-profile-service';
import { getUser } from '../../shared/auth-service';
import AlertDialogQuestion from '../alert-dialog-question';
import WarningIcon from '@mui/icons-material/Warning';

const Compensation = () => {
  const [fecha, setFecha] = useState(null);
  const [data, setData] = useState(null);
  const [id, setId] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [action, setAction] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [employeePositionId, setEmployeePositionId] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [optionDetails, setOptionDetails] = useState(null);
  const [uniquePositions, setUniquePositions] = useState([]);
  const user = getUser();
  const [loading, setLoading] = useState(true);
  const [airports, setAirports] = useState([]);
  const [selectedAirport, setSelectedAirport] = useState(0);
  const [selectedFecha, setSelectedFecha] = useState(null);
  const [selectedCantidad, setSelectedCantidad] = useState(null);
  const [alertQuestionOpen, setAlertQuestionOpen] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [employeePositions, setEmployeePositions] = useState([]);
  const [dataReturnImport, setDataReturnImport] = useState([]);
  const [zones, setZones] = useState([]);
  const companyId = user.countryCode.split('-')[0];

  useEffect(() => {
    async function fetchData() {
      if (loading) {
        try {
          const data = await getRequired();
          const employeePositionsData = await getPositionHomologationEngrana();
          const zonesData = await getZones(); 
          setEmployeePositions(employeePositionsData);
          setZones(zonesData);
          const airportsData = await getAllAirports(companyId);
          //(zonesData);
          setSelectedAirport(user.airport.id);
          //console.log('info employee');
          //console.log(data);
          setAirports(airportsData);
          const profiles = await getAllProfile(companyId);
          setLoading(false);
          setData(data);
          setProfiles(profiles);
        } catch (error) {
          setError(error.message);
          setLoading(false);
          setData([]);
        }
      }
    }
    fetchData();
  });

  useEffect(() => {
    if (data) {
      setUniquePositions(getUniquePositions(data));
    }
  }, [data]);

  const getUniquePositions = (data) => {
    const unique = {};
    data.forEach((item) => {
      if (!unique[item.profile]) {
        unique[item.profile] = item;
      }
    });
    //console.log(unique);
    return Object.values(unique);
  };

  const handleCloseAlert = () => {
    setAlertQuestionOpen(false);
    setIdDelete(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // const handleSave = async (airportId,employeePositionId,mes,anio,cantidad,observation) => {
  //   await updateDataRequired(airportId,employeePositionId,mes,anio,cantidad,observation);
  //   setShowModal(false);
  //   setLoading(true);
  //   enqueueSnackbar(MESSAGES.SAVED);
  // };


  const handleSave = async (airportId, employeePositionId,zonaId, mes, anio, cantidad, observation) => {  
    const data = {
      "base" : airportId,
      "cargo":employeePositionId,
      "zonaId":zonaId,
      "anio":anio, 
      "mes":mes, 
      "cantidadRequerida":cantidad, 
      "observacion":observation,
    };
    // Crear un arreglo y agregar el objeto
    const dataArray = [];
    dataArray.push(data);
    // Pasar los datos a la función updateDataRequired
    await updateDataRequired(dataArray);

    setShowModal(false);
    setLoading(true);
    enqueueSnackbar(MESSAGES.SAVED);
  };

  const handleDelete = async (cellValues) => {
    //console.log(cellValues);
    await deleteSelectedProfile(idDelete);
    setShowModal(false);
    setAlertQuestionOpen(false);
    setLoading(true);
    enqueueSnackbar(MESSAGES.DELETE);
  };

  const handleNew = async () => {
    setSelectedItem({});
    setId(null);
    setShowModal(true);
    setDataReturnImport('');
    setAction(ACTIONS.NEW);
  };

  const handleActionButton = (e, cellValues, action) => {
    e.stopPropagation();
    setId(cellValues.row.id);
    setAction(action);
  };

  const handleEdit = (e, cellValues) => {
    e.stopPropagation(); 
    //setEmployee(cellValues.row.description)
    //console.log('data de la fila');
    //console.log(cellValues.row);
    setSelectedAirport(cellValues.row.aeropuertoId)
    setEmployeePositionId(cellValues.row.cargoId);
    setSelectedCantidad(cellValues.row.cantidad);
    setSelectedFecha(cellValues.row.fecha);
    fetchOptionDetails(cellValues.row.id); 
  }

  const handleSaveImport = async (
    data
    ) => {
        try {

           var response = await SaveAllRequiredExcel(data);

           setShowModal(false);

           if(response.data.length > 0){
            setDataReturnImport(response.data);
            enqueueSnackbar("Hay errores de validación");
           }
           else{
            setLoading(true);
            enqueueSnackbar(MESSAGES.SAVED);
           }
           
        } catch (error) {
            setError(error.message);
        }

  };

  const fetchOptionDetails = async (id) => {
    try {
      setOptionDetails('');
      setShowModal(true);
      setAction(ACTIONS.Edit);
    } catch (error) {
      setError(error.message);
    } finally {
    }
  };

  const columnsResponse = [
    { field: 'id', headerName: 'Id', width: 60 },
    { field: 'base', headerName: 'Base', width: 200 },
    { field: 'date', headerName: 'Fecha', width: 150 },
    {
        field: "message",
        headerName: "Mensaje",
        width: 900,
        sortable: false,
        renderCell: params => {
            return (<><WarningIcon sx={{color: 'orange', mr:'10px'}}/> <b> {params.value} </b></>                     
            );
        }
    }
];


  const columns = [
    { field: 'id', headerName: 'Código', miwidth: 100, flex: 0.2, hide: true },
    {
      field: 'aeropuertoId',
      headerName: 'AeropuertoId',
      minwidth: 350,
      flex: 1,
      hide: true,
      valueGetter: (params) => `${params.row.aeropuertoId || ''}`,
    },
    {
      field: 'aeropuerto',
      headerName: 'Aeropuerto',
      minwidth: 350,
      flex: 0.3,
      headerAlign: 'center',align: 'center',
      valueGetter: (params) => `${params.row.aeropuerto || ''}`,
    },
    {
      field: 'cargoId',
      headerName: 'CargoId',
      minwidth: 350,
      flex: 1,
      hide: true,
      valueGetter: (params) => `${params.row.cargoId || ''}`,
    },
    {
      field: 'cargo',
      headerName: 'Cargo Engrana',
      minwidth: 350,
      flex: 0.6,
      headerAlign: 'center',align: 'center',
      valueGetter: (params) => `${params.row.cargo || ''}`,
    },
    {
      field: 'zona',
      headerName: 'Zona',
      minwidth: 350,
      flex: 0.6,
      headerAlign: 'center',align: 'center',
      valueGetter: (params) => `${params.row.zona || ''}`,
    }, 
    {
        field: 'fecha',
        headerName: 'Fecha',
        minwidth: 350,
        flex: 0.3,
        headerAlign: 'center',align: 'center',
        valueGetter: (params) => `${params.row.fecha}`,
    },
    {
      field: 'cantidad',
      headerName: 'Cantidad Requerida',
      type: 'number',
      minwidth: 150,
      flex: 0.3,
      align: 'center', headerAlign: 'center',
      valueGetter: (params) => params.row.cantidad,
    },
    {
      field: 'observacion',
      headerName: 'Observación',
      type: 'number',
      minwidth: 150,
      flex: 0.8,
      align: 'center', headerAlign: 'center',
      valueGetter: (params) => params.row.observacion,
    },
  ];

  if (loading) {
    return (
      <BackDrop />
    );
  }

  if (error) {
    return (<ErrorSnackbar message={error} />);
  }

  return (
    <>
      {showModal && <RequiredDetail
        data={optionDetails}
        profiles={profiles}
        handleClose={handleCloseModal}
        handleSave={handleSave}
        airportId={selectedAirport}
        employeePositions = {employeePositions}
        zones = {zones}
        airports={airports}
        action={action}
        handleSaveImport={handleSaveImport}
      />}

      {alertQuestionOpen && <AlertDialogQuestion
        handlePositive={handleDelete}
        handleNegative={handleCloseAlert}
        textButtonPositive={ACTIONS.ACCEPT}
        textButtonNegative={ACTIONS.CANCEL}
        dialogContentText={MESSAGES.CONFIRM_DELETE}
        dialogTitle={""}
        open={alertQuestionOpen}
        elemento={""}
      />}

<Grid container spacing={2}>
      <Grid item xs={10}>
        <Typography variant="h5" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ flexGrow: 1, m: 1 }}>
          Gestión de <span style={{ color: '#00b0ef' }}>Requeridos</span>
        </Typography>
      </Grid>
      <Box sx={{ m: 4 }}>
        <Grid item xs={2}>
          <Button
            endIcon={<AddCircle />}
            variant="contained"
            onClick={() => { handleNew() }} autoFocus>
            {ACTIONS.NEW}
          </Button>
        </Grid>
      </Box>
    </Grid>

     {/* Añadimos un espacio entre las tablas */}
     <Grid> {/* Agrega un margen superior de 4 */}
      {dataReturnImport.length > 0 && (
        <>
          <Typography variant="h6" style={{ color: '#1a3072' }} fontWeight="bold" sx={{ flexGrow: 1, m: 1 }}>
            Errores de validación
          </Typography>
          <DataTable columns={columnsResponse} rows={dataReturnImport} />
        </>
      )}
      </Grid>
    <Box mt={4}>
      <DataTable 
        columns={columns} 
        rows={data} 
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 'bold',
          }
        }} 
      />
    </Box>

   
    </>
  );
};

export default Compensation;
